import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  uploadDateTooltip: {
    key: `OwnedTopicsTab-uploadDateTooltip`,
    defaultValue: 'Dados referentes a vídeos publicados neste período',
  },
})
